<template>
  <bita-modal
    :id="modalId"
    :title="' سالن های ' + user.full_name"
    :isLoading="isLoading"
    :modal-lg="true"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div
            class="d-flex align-items-center"
            style="justify-content: space-between;"
          >
            <bita-select
              name="salon"
              label="سالن"
              validation-container-class="col-lg-4"
              input-class="form-control"
              :data-source="salons"
              data-text-field="name"
              data-value-field="id"
              v-model="dataForm.salon_id"
            />
            <div class="d-flex align-items-center">
              <bita-bootbutton
                type="primary"
                style="height: 33px"
                title="ذخیره"
                btn-width="100px"
                class="mt-3"
                @click.native="submit"
              />
            </div>
          </div>

          <table class="table mt-2">
            <thead>
              <tr>
                <th>سالن</th>
                <th> سالن پیش فرض </th>
                <th> عملیات </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in salonsOfUser" :key="index" >
                <td>
                  {{ item.name }} ({{ item.terminal_name }})
                </td>
                <td>
                  <span class="badge badge-info" v-if="item.is_default" > فعال </span>
                  <span class="badge badge-danger" v-else > غیر فعال </span>
                </td>
                <td>
                  <a role='button' @click="enableDefaultSalon(item)" title='فعال کردن سالن پیش فرض'><span class='fas fa-lock' style='color:red; font-size: 15px'></span></a>

                  <a class="mx-4" role='button' @click="deleteSalonOfUser(item)" title='حذف'><span class='fas fa-times' style='color:red; font-size: 15px'></span></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </bita-form>
    </div>
  </bita-modal>
</template>

<script>
import Spinner from "../../../components/Spinner";
export default {
  components: { Spinner },
  props: {
    modalId: {},
    title: {},
    propsDriver: {},
  },
  data() {
    return {
      user: {},
      dataForm: {
        user_id: "",
        salon_id: "",
      },
      isLoading: false,
      salons: [],
      salonsOfUser: [],
    };
  },
  mounted() {
    this.$persistClient("get", "salons").then((res) => {
      this.salons = res.data;
    });
  },
  watch: {
    propsDriver: function(_data) {
      this.user = _data;
      this.dataForm.user_id = this.user.id;

      this.getData();
    },
  },
  methods: {
    getData() {
      this.isLoading = true;
      this.$persistClient("get", `user/salons?user_id=${this.dataForm.user_id}`)
        .then((res) => {
          this.salonsOfUser = res.data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submit() {
      this.isLoading = true;
      this.$persistClient(
        "post",
        `user/salons`,
        this.dataForm
      )
        .then((res) => {
          this.dataForm.salon_id = "";
          this.getData();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    deleteSalonOfUser( salonOfUser ) {
      this.$alert("question", `آیا از حذف  ${salonOfUser.name} اطمینان دارید ؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.$persistClient("delete", `user/salons/?salon_id=${salonOfUser.salon_id}&user_id=${salonOfUser.user_id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
            })
            .finally(() => {
              this.getData()
            });
        }
      });
    },
    enableDefaultSalon( salonOfUser ) {
      this.$alert("question", `آیا از پیش فرض قرار دادن  ( ${salonOfUser.name} ) اطمینان دارید ؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.$persistClient("post", `user/salons/default/?salon_id=${salonOfUser.salon_id}&user_id=${salonOfUser.user_id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
            })
            .finally(() => {
              this.getData()
            });
        }
      });
    },
  },
};
</script>
